<template>
    <div>
        <div class="input-number-range" :class="{ 'is-disabled': disabled }">
            <div class="flex">
                <div class="from">
                    <!--
                    blur:最小值失焦事件
                    focus:最小值聚焦事件
                    input:最小值输入事件
                    change:最小值change事件
                    -->
                    <el-input
                        ref="input_from"
                        v-model="userInputFrom"
                        :disabled="disabled"
                        :placeholder="fromPlaceholder || $t('minimum')"
                        clearable
                        @blur="handleBlurFrom"
                        @focus="handleFocusFrom"
                        @input="handleInputFrom"
                        @change="handleInputChangeFrom"
                    ></el-input>
                </div>
                <div class="center">
                    <span>~</span>
                </div>
                <div class="to">
                    <!--
                   blur:最大值失焦事件
                   focus:最大值聚焦事件
                   input:最大值输入事件
                   change:最大值change事件
                   -->
                    <el-input
                        ref="input_to"
                        v-model="userInputTo"
                        :disabled="disabled"
                        :placeholder="toPlaceholder || $t('maximum')"
                        clearable
                        @blur="handleBlurTo"
                        @focus="handleFocusTo"
                        @input="handleInputTo"
                        @change="handleInputChangeTo"
                    ></el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "InputNumberRange",
    props: {
      value: {required: true},
      fromPlaceholder: {
        type: String,
        default: ''
      },
      toPlaceholder: {
        type: String,
        default: ''
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
      // 精度参数
      precision: {
        type: Number,
        default: 0,
        validator(val) {
          return val >= 0 && val === parseInt(val, 10);
        },
      },
    },
    data() {
      return {
        userInputFrom: null, // 最小值
        userInputTo: null, // 最大值
      };
    },
    watch: {
      /** 监听value实现双向绑定 */
      value: {
        immediate: true,
        handler(value) {
          // 判断是否为数字number类型
          if (value instanceof Array && this.precision !== undefined) {
            let fromVal =
              value[0] !== undefined && value[0] !== null && typeof value[0] === "number" ? value[0] : null;
            let toVal =
              value[1] !== undefined && value[1] !== null && typeof value[1] === "number" ? value[1] : null;
            this.userInputFrom = fromVal
            this.userInputTo = toVal
          }
        },
      },
    },

    methods: {
      // 根据精度保留数字
      toPrecision(num, precision) {
        if (precision === undefined) precision = 0;
        return parseFloat(
          Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)
        );
      },

      /** 触发以下事件时自动向上冒泡执行(通过emit将事件抛给element input组件) */
      handleBlurFrom(event) {
        this.$emit("blurFrom", event);
      },

      handleFocusFrom(event) {
        this.$emit("focusFrom", event);
      },

      handleBlurTo(event) {
        this.$emit("blurTo", event);
      },

      handleFocusTo(event) {
        this.$emit("focusTo", event);
      },

      handleInputFrom(value) {
        this.$emit("inputFrom", value);
        this.userInputFrom = value;
      },

      handleInputTo(value) {
        this.$emit("inputTo", value);
        this.userInputTo = value;
      },

      // from输入框change事件
      handleInputChangeFrom(value) {
        const newVal = this.setPrecisionValue(value);
        this.userInputFrom = newVal;
        // 如果初始化数字的精度不符合代码设置时重置数字
        this.userInputTo = this.setPrecisionValue(this.userInputTo);
        if (!this.userInputFrom && this.userInputFrom !== 0 && !this.userInputTo && this.userInputTo !== 0) {
          this.$emit("input", []);
          this.$emit("changeFrom", newVal);
          return;
        }

        if (!this.userInputTo) {
          this.userInputFrom = newVal;
        } else {
          // 最小值大于最大值时逻辑判断
          this.userInputFrom =
            !newVal || parseFloat(newVal) <= parseFloat(this.userInputTo)
              ? newVal
              : this.userInputTo;
        }
        this.$emit("input", [this.userInputFrom, this.userInputTo]);
        this.$emit("changeFrom", newVal);
      },

      // to输入框change事件
      handleInputChangeTo(value) {
        const newVal = this.setPrecisionValue(value);
        this.userInputTo = newVal;
        this.userInputFrom = this.setPrecisionValue(this.userInputFrom);
        if (!this.userInputFrom && this.userInputFrom !== 0 && !this.userInputTo && this.userInputTo !== 0) {
          this.$emit("input", []);
          this.$emit("changeTo", newVal);
          return;
        }

        if (!this.userInputFrom) {
          this.userInputTo = newVal;
        } else {
          // 最大值小于最小值时逻辑判断
          this.userInputTo =
            !newVal || parseFloat(newVal) >= parseFloat(this.userInputFrom)
              ? newVal
              : this.userInputFrom;
        }
        this.$emit("input", [this.userInputFrom, this.userInputTo]);
        this.$emit("changeTo", newVal);
      },

      // 设置成精度数字
      setPrecisionValue(value) {
        if (value === undefined || value === null || value === "") return null;
        const newVal = Number(value);
        // 如果是非数字空返回null
        if (isNaN(value)) return null;
        if (typeof newVal === "number" && this.precision !== undefined) {
          const val = this.toPrecision(value, this.precision);
          return val;
        }
        return null;
      },
    }
  }
</script>

<style scoped>
    /*取消element原有的input框样式*/
    ::v-deep .el-input .el-input__inner {
        border: 0px;
        margin: 0;
        padding: 0 15px;
        background-color: transparent;
        text-align: center;
    }

    .input-number-range {
        background-color: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
    }

    .flex {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    .flex .center {
        margin-top: 1px;
    }

    .is-disabled {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        cursor: not-allowed;
    }
</style>